import { X } from "lucide-react"
import { Button } from "@/components/ui/button"

interface BulkActionBarProps {
  count: number
  onClear: () => void
  children: React.ReactNode
}

export function BulkActionBar({ count, onClear, children }: BulkActionBarProps) {
  if (count === 0) return null

  return (
    <div className="flex items-center gap-3 rounded-lg glass-card p-3 animate-in fade-in slide-in-from-top-2 duration-200">
      <span className="text-sm font-medium tabular-nums">{count} selected</span>
      <div className="flex items-center gap-2">{children}</div>
      <Button variant="ghost" size="icon" className="h-7 w-7 ml-auto" onClick={onClear} aria-label="Clear selection">
        <X className="h-3.5 w-3.5" />
      </Button>
    </div>
  )
}
